import React, { useEffect, useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import LoadAlerts from '../../LoadAlerts';
import InternalError from '../../generales/InternalError';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';

const ModalDiagnosticNew = ({ eventId, props, onClose }) => {
  const token_item = localStorage.getItem('access_token');
  const [internalError, setInternalError] = useState(false);
  const [dataAnalisis, setDataAnalisis] = useState({ data: [], loading: true, error: null });

  useEffect(() => {
    search_event();
  }, []);

  const search_event = async () => {
    setDataAnalisis({ data: [], loading: true, error: null });
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/diagnosta/' + props.data.ip, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token_item}`,
        },
      });
      if (response.ok) {
        const response_data = await response.json();
        setDataAnalisis({ data: response_data.data, loading: false, error: null });
      } else {
        throw new Error('Error en la solicitud');
      }
    } catch (error) {
      setInternalError(true);
    }
  };

  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const dia = String(ahora.getDate()).padStart(2, '0');
    const horas = String(ahora.getHours()).padStart(2, '0');
    const minutos = String(ahora.getMinutes()).padStart(2, '0');
    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };

  const handleExport = () => {
    const input = document.getElementById('diagnostic-modal-content');
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 100);
      pdf.save(`diagnosta-${eventId}-${obtenerFechaActualLocal()}.pdf`);
    });
  };

  if (internalError) return <InternalError />;

  const dispositivos = dataAnalisis.data || [];
  const totalDependientes = dispositivos.length;
  const dispositivosAfectados = dispositivos.filter(d => !d.conectado).length;

  // Logic for device status badge
  const isODD = props.data.tipo === 1;
  const isDown = props.data.status === 'PROBLEM' || !props.data.status; // Adjust based on actual data
  const deviceStatus = isODD ? 'ODD' : (isDown ? 'DOWN' : 'UP');

  const getStatusStyle = (status) => {
    switch (status) {
      case 'ODD': return { background: '#ede9fe', color: '#7e3af2', border: '1px solid #c4b5fd' };
      case 'DOWN': return { background: '#fce7f3', color: '#db2777', border: '1px solid #fbcfe8' };
      case 'UP': return { background: '#d1fae5', color: '#057a55', border: '1px solid #a7f3d0' };
      default: return {};
    }
  };

  return (
    <div style={{
      background: 'rgba(15,30,56,0.55)',
      backdropFilter: 'blur(2px)',
      position: 'fixed', inset: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 12,
        width: '100%',
        height: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,.3), 0 0 0 1px rgba(255,255,255,.05)',
        overflow: 'hidden',
        animation: 'slideUp 0.2s ease'
      }} id="diagnostic-modal-content">
        <style>{`
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(12px) }
            to   { opacity: 1; transform: translateY(0) }
          }
        `}</style>

        {/* HEADER */}
        <div style={{ background: '#0f2d5e', padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 30, height: 30, borderRadius: 7,
              background: 'rgba(255,255,255,.12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="6.5" stroke="#fff" strokeWidth="1.3" />
                <line x1="8" y1="4" x2="8" y2="8.5" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
                <circle cx="8" cy="10.8" r=".9" fill="#fff" />
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>
                {capitalizeFirstLetter(lang[props.languaje]['diagnosticoEvento'])}
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,.5)', marginTop: 1 }}>
                Análisis de arrastre de dispositivos dependientes
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <button style={{
              display: 'flex', alignItems: 'center', gap: 5,
              border: '0.5px solid rgba(255,255,255,.2)',
              background: 'rgba(255,255,255,.1)',
              borderRadius: 6, padding: '5px 10px',
              fontSize: 10, color: 'rgba(255,255,255,.85)', cursor: 'pointer'
            }} onClick={handleExport}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
              Exportar
            </button>
            <button style={{
              width: 26, height: 26, borderRadius: 6,
              border: '0.5px solid rgba(255,255,255,.15)',
              background: 'rgba(255,255,255,.08)',
              cursor: 'pointer', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,.6)'
            }} onClick={onClose}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
        </div>

        {/* EVENT META BAR */}
        <div style={{ background: '#f1f5f9', borderBottom: '1px solid #e2e8f0', padding: '8px 18px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>Event ID</span>
            <span style={{
              fontFamily: 'monospace', fontSize: 11, fontWeight: 500,
              color: '#1a56db', background: '#e8f0fe',
              border: '1px solid #c3dafe', borderRadius: 4, padding: '2px 8px'
            }}>
              {eventId}
            </span>
          </div>
          <span style={{ color: '#cbd5e1', fontSize: 12 }}>|</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>Estatus</span>
            <span style={{
              background: '#fee2e2', color: '#e02424', border: '1px solid #fca5a5',
              borderRadius: 4, padding: '2px 8px', fontSize: 10, fontWeight: 600
            }}>
              {props.data.status || 'PROBLEM'}
            </span>
          </div>
          <span style={{ color: '#cbd5e1', fontSize: 12 }}>|</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>Dispositivos afectados</span>
            <span style={{
              background: '#fce7f3', color: '#db2777', border: '1px solid #fbcfe8',
              borderRadius: 10, padding: '1px 7px', fontSize: 9, fontFamily: 'monospace'
            }}>
              {dispositivosAfectados} desconectados
            </span>
          </div>
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 4, fontSize: 9, color: '#64748b' }}>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
            El dispositivo origen genera arrastre en sus dependientes
          </div>
        </div>

        {/* BODY */}
        <div style={{ padding: '16px 18px' }}>
          {dataAnalisis.loading ? <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><LoadAlerts languaje={props.languaje} /></div> : (
            <>
              {/* Device Card */}
              <div style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px 14px', marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid #e2e8f0' }}>
                  <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>
                    {capitalizeFirstLetter(lang[props.languaje]['dataHostDiag'])}
                  </span>
                  <span style={{
                    ...getStatusStyle(deviceStatus),
                    borderRadius: 4, padding: '2px 8px',
                    fontSize: 10, fontWeight: 600
                  }}>
                    {deviceStatus}
                  </span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 10 }}>
                  <div>
                    <div style={{ fontSize: 8, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 3 }}>Dispositivo</div>
                    <div style={{ fontSize: 12, fontWeight: 500, color: '#1a56db' }}>{props.data.Host}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 8, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 3 }}>IP</div>
                    <div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500, color: '#334155' }}>{props.data.ip}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 8, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 3 }}>Problema</div>
                    <div style={{ fontSize: 11, fontWeight: 400, color: '#e02424' }}>{props.data.Problem}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 8, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 3 }}>Tecnología</div>
                    <div style={{ fontSize: 12, fontWeight: 500, color: '#334155' }}>{dispositivos[0]?.tech_name || '-'}</div>
                  </div>
                </div>
              </div>

              {/* Section label */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em', whiteSpace: 'nowrap' }}>
                  {capitalizeFirstLetter(lang[props.languaje]['arrastreHostDependientes'])}
                </span>
                <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
                <span style={{
                  background: '#f1f5f9', border: '1px solid #e2e8f0',
                  borderRadius: 10, padding: '1px 7px', fontSize: 9, color: '#64748b',
                  fontFamily: 'monospace'
                }}>
                  {totalDependientes} dispositivos
                </span>
              </div>

              {/* Table */}
              <div style={{ borderRadius: 8, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#0f2d5e' }}>
                      <th style={{ padding: '8px 12px', color: '#fff', fontSize: 9, fontWeight: 500, textAlign: 'left', letterSpacing: '.06em', textTransform: 'uppercase', borderRight: '1px solid rgba(255,255,255,.08)', width: 130 }}>
                        {capitalizeFirstLetter(lang[props.languaje]['tecnologia'])}
                      </th>
                      <th style={{ padding: '8px 12px', color: '#fff', fontSize: 9, fontWeight: 500, textAlign: 'left', letterSpacing: '.06em', textTransform: 'uppercase', borderRight: '1px solid rgba(255,255,255,.08)', width: 110 }}>IP</th>
                      <th style={{ padding: '8px 12px', color: '#fff', fontSize: 9, fontWeight: 500, textAlign: 'left', letterSpacing: '.06em', textTransform: 'uppercase', borderRight: '1px solid rgba(255,255,255,.08)' }}>
                        {capitalizeFirstLetter(lang[props.languaje]['nombre'])}
                      </th>
                      <th style={{ padding: '8px 12px', color: '#fff', fontSize: 9, fontWeight: 500, textAlign: 'center', letterSpacing: '.06em', textTransform: 'uppercase', width: 120 }}>
                        {capitalizeFirstLetter(lang[props.languaje]['conectado'])}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dispositivos.map((d, i) => {
                      const isRoot = d.origen === 1;
                      return (
                        <tr key={i} style={{ background: isRoot ? '#fce7f3' : '#fff' }}>
                          <td style={{ padding: '9px 12px', borderBottom: '1px solid #f1f5f9', borderRight: '1px solid #f1f5f9' }}>
                            <span style={{
                              display: 'inline-block',
                              background: isRoot ? '#fce7f3' : '#f1f5f9',
                              border: isRoot ? '1px solid #fbcfe8' : '1px solid #e2e8f0',
                              borderRadius: 4, padding: '2px 7px',
                              fontSize: 9, fontWeight: 500,
                              color: isRoot ? '#db2777' : '#334155'
                            }}>
                              {d.tech_name}
                            </span>
                            {isRoot && (
                              <span style={{
                                display: 'inline-flex', alignItems: 'center', gap: 4,
                                background: '#db2777', color: '#fff',
                                borderRadius: 4, padding: '2px 7px',
                                fontSize: 8, fontWeight: 600,
                                marginLeft: 6, textTransform: 'uppercase', letterSpacing: '.05em'
                              }}>
                                Origen
                              </span>
                            )}
                          </td>
                          <td style={{ padding: '9px 12px', borderBottom: '1px solid #f1f5f9', borderRight: '1px solid #f1f5f9' }}>
                            <span style={{ fontFamily: 'monospace', fontSize: 9, color: isRoot ? '#db2777' : '#64748b' }}>
                              {d.ip}
                            </span>
                          </td>
                          <td style={{ padding: '9px 12px', borderBottom: '1px solid #f1f5f9', borderRight: '1px solid #f1f5f9', fontSize: 10, fontWeight: isRoot ? 600 : 400, color: isRoot ? '#db2777' : '#334155' }}>
                            {d.host}
                          </td>
                          <td style={{ padding: '9px 12px', borderBottom: '1px solid #f1f5f9', textAlign: 'center' }}>
                            <span style={{
                              fontSize: 10, fontWeight: 600,
                              color: d.conectado ? '#057a55' : '#db2777'
                            }}>
                              {d.conectado ? capitalizeFirstLetter(lang[props.languaje]['conectado']) : capitalizeFirstLetter(lang[props.languaje]['desconectado'])}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        {/* FOOTER */}
        <div style={{ padding: '10px 18px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid #e2e8f0', background: '#f1f5f9' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 10, color: '#64748b' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
            1 dispositivo origen · {totalDependientes - 1} dependientes afectados
          </div>
          <div style={{ display: 'flex', gap: 7 }}>
            <button style={{
              background: '#fff', color: '#334155',
              border: '1px solid #e2e8f0', borderRadius: 7,
              fontSize: 11, fontWeight: 500, padding: '7px 16px', cursor: 'pointer'
            }} onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDiagnosticNew;
